module.exports = __webpack_public_path__ + "img/conectar-ico.a4e6a55c.png";